import type { PageContext } from '@zto/zpage'
import { commonOptions } from '@/config/options'
import { RbacResourceType, RbacResourceTypeName, SystemResourceLevel } from '@/config/enums'


const buildSecondResources = (list: any[], parentCode: string) => {
  if(!list || !parentCode){
    return []
  }
  return list.filter((n: any) => n.resourceLevel === SystemResourceLevel.LEVEL_2 && n.parentCode === parentCode)
             .sort((a: any, b: any) => a.sortNum - b.sortNum)
}
/**
 * 资源新增 / 编辑共用弹窗（表单字段与交互按 isEdit 区分）
 */
export function resourceDialog(isEdit: boolean) {
  return {
    width: 560,
    labelWidth: 120,
    itemSpan: 24,
    onShow: async ({ data, app }: PageContext) => {
      // console.info('🚀 ~ file:_dialogs method:onShow line:148 ----- data', data)
      let firstResourceCode = ''
      let secondResourceCode = ''
      let secondResourceList = []

      const res = await app.request({
        api: "/base_user/admin/resource/list",
        params: {}
      })
      const resources = res || []

      // 编辑时填充数据
      if (isEdit) {
        const resourceLevel = data.resourceLevel
        if(resourceLevel === SystemResourceLevel.LEVEL_2){
          firstResourceCode = data.parentCode
        }else if(resourceLevel === SystemResourceLevel.LEVEL_3){
          secondResourceCode = data.parentCode
          firstResourceCode = resources.find((n: any) => n.resourceCode === secondResourceCode)?.parentCode
          secondResourceList = buildSecondResources(resources, firstResourceCode)
          // console.info('🚀 ~ file:_dialogs method:onShow line:168 ----- firstResourceCode', firstResourceCode)
          // console.info('🚀 ~ file:_dialogs method:onShow line:168 ----- secondResourceCode', secondResourceCode)
          // console.info('🚀 ~ file:_dialogs method:onShow line:168 ----- secondResourceList', secondResourceList)
        }
      }

      // const resourceList = buildResourceTree(resources)
      return {
        payload: {
          ...(data || {}),
          firstResourceList: resources.filter((n: any) => n.resourceLevel === SystemResourceLevel.LEVEL_1).sort((a: any, b: any) => a.sortNum - b.sortNum),
          secondResourceList,
          firstResourceCode,
          secondResourceCode,
          resourceList: resources
        }
      }
    },
    formItems: [
      {
        type: 'select',
        prop: 'resourceLevel',
        label: '资源级别',
        options: commonOptions.systemResourceLevels,
        default: SystemResourceLevel.LEVEL_1,
        required: true,
        onChange: async (model: any, val: any) => {
          console.info('🚀 ~ file:_dialogs_dialogs method:onChange line:97 ----- model', model)
          console.info('🚀 ~ file:_dialogs_dialogs method:onChange line:97 ----- val', val)
          if(val === SystemResourceLevel.LEVEL_3){
            model.secondResourceCode = undefined
            model.secondResourceList = buildSecondResources(model.resourceList, model.firstResourceCode)
          }
        }
      },
      //
      {
        type: 'select',
        prop: 'firstResourceCode',
        label: '一级资源',
        optionValueProp: 'resourceCode',
        optionLabelProp: 'resourceName',
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = [SystemResourceLevel.LEVEL_2, SystemResourceLevel.LEVEL_3].includes(Number(data.resourceLevel))
          return {
            visible,
            required: visible,
            options: data.firstResourceList || []
          }
        },
        onChange: async (model: any, val: any) => {
          console.info('🚀 ~ file:_dialogs_dialogs method:onChange line:97 ----- model', model)
          console.info('🚀 ~ file:_dialogs_dialogs method:onChange line:97 ----- val', val)
          // model.buildingNumber = ext.option.buildingNumber
          model.secondResourceCode = undefined
          // model.secondResourceList = model.resourceList.find(
          //   (n: any) => n.resourceCode === val
          // )?.children || []
          model.secondResourceList = buildSecondResources(model.resourceList, val)
        }
      },
      {
        type: 'select',
        prop: 'secondResourceCode',
        label: '二级资源',
        optionValueProp: 'resourceCode',
        optionLabelProp: 'resourceName',
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = [ SystemResourceLevel.LEVEL_3].includes(Number(data.resourceLevel))
          return {
            visible,
            required: visible,
            options: data.secondResourceList || [],
            disabled: !data.firstResourceCode
          }
        }
      },
      {
        type: 'select',
        prop: 'resourceType',
        label: '资源类型',
        options: commonOptions.rbacResourceType,
        default: RbacResourceType.PAGE,
        required: true
      },
      {
        type: 'input',
        prop: 'resourceName',
        label: '资源名称',
        trim: true,
        maxlength: 10,
        required: true
      },
      {
        type: 'input',
        prop: 'resourceCode',
        label: '资源编码',
        trim: true,
        maxlength: 100,
        required: true
      },
      {
        type: 'input',
        prop: 'resourcePath',
        label: '资源路径',
        trim: true,
        maxlength: 100,
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = [SystemResourceLevel.LEVEL_3].includes(Number(data.resourceLevel))
          return {
            required: visible
          }
        },
      },
      {
        type: 'input-number',
        prop: 'sortNum',
        label: '排序',
        min: 0,
        max: 99999,
        precision: 0,
        required: true
      }
    ],
    beforeSubmit: async ({ data }: PageContext, model: any) => {
      console.info('🚀 ~ file:_dialogs method:beforeSubmit line:176 ----- data', data)
      const { id, firstResourceCode, secondResourceCode, resourceLevel, resourceType, resourceName, resourceCode, resourcePath, sortNum  } = data || {}
      let parentCode = ''
      if(resourceLevel === SystemResourceLevel.LEVEL_2){
        parentCode = firstResourceCode
      }else if(resourceLevel === SystemResourceLevel.LEVEL_3){
        parentCode = secondResourceCode
      }
      return {
        id,
        parentCode,
        resourceType,
        resourceName,
        resourceCode,
        resourcePath,
        resourceLevel,
        sortNum
      }
    },
    actions: {
      close: {},
      submit: { label: isEdit ? '保存' : '确定' }
    }
  }
}

export function addResourceDialog() {
  return resourceDialog(false)
}

export function editResourceDialog() {
  return resourceDialog(true)
}

export function resourceTypeColumnFormatter(row: any) {
  return (RbacResourceTypeName as any)[row.resourceType] || row.resourceType
}
